<script>

  import bookDefault from './book-default.vue'

  export default {
    extends: bookDefault,
  }

</script>

<template lang="pug">

div.book-drawer.pr4
  template(v-if="livre")
    header.header
      cover-book.cover(:cover="livre && livre.couverture")
      div.infos
        h4.title {{ livre.titre }}
        h6.subtitle.auteurs
          b {{ auteurs }}
    div.desc.content.f5.lh-copy(v-html="livre.description")
</template>

<style lang="postcss" scoped>

  .book-drawer {
    & .header {
      display: flex;
      margin-bottom: 20px;
    }
    & .cover {
      flex: 0 0 20%;
      margin-right: 20px;
    }
    & .desc {
      /*font-size: 1.4em;*/
    }
  }
</style>



// WEBPACK FOOTER //
// book-drawer.vue?4517280a